import React, { useState, useCallback } from 'react';

import { Button, Textarea } from '@ontruck/orc';
import styled from 'styled-components';

const t = {
  label_pool:
    'Add drivers to this pool inserting their phone numbers with prefix (00) separated by a comma.',
  input_example: 'Example: 0048530040245,00447576001281',
  assign_button: 'Launch to this pool',
  error_msg: 'The following inputs are incorrect: ',
};

const ErrorParagraph = styled.p`
  font-weight: bold;
  color: #fff;
  word-break: break-all;
`;

const CustomPoolAssignment = ({ className, onAssign }) => {
  const [drivers, setDrivers] = useState('');
  const [error, setError] = useState([]);

  const handleChangeComment = useCallback(
    (_, { value }) => {
      const newValue = value.split(',').map((phone) => phone.replace(/\s/g, ''));
      const errorInput = newValue.filter((phone) => !phone.trim().match(/^\d{13,14}$/));
      error && setError(errorInput);
      setDrivers(newValue.join(','));
    },
    [setDrivers, error]
  );

  const handleAssignment = useCallback(() => {
    const filteredDrivers = drivers.split(',');
    onAssign && onAssign({ drivers: filteredDrivers });
  }, [onAssign, drivers]);

  const hasError = error.length >= 1;
  const isButtonDisabled = !drivers || hasError;

  return (
    <div className={className}>
      <div className="form-control">
        <p className="placeholder">{t.label_pool}</p>
        <p className="placeholder">{t.input_example}</p>
        <div className={`textarea ${hasError ? 'input-error' : ''}`} data-testid="textarea">
          <Textarea value={drivers} label={'Add drivers'} onChange={handleChangeComment} />
        </div>
        {hasError && (
          <ErrorParagraph>
            {t.error_msg}
            {error.map((msg) => ` ${msg}`)}
          </ErrorParagraph>
        )}
      </div>
      <Button fullWidth className="button" onClick={handleAssignment} disabled={isButtonDisabled}>
        {t.assign_button}
      </Button>
    </div>
  );
};

export default CustomPoolAssignment;
